import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button } from '../button/button';

@Component({
  selector: 'app-batch-completed-modal',
  standalone: true,
  imports: [CommonModule, Button],
  templateUrl: './batch-completed-modal.html',
  styleUrl: './batch-completed-modal.css'
})
export class BatchCompletedModal {
  @Output() cancel = new EventEmitter<void>();
  @Output() viewAll = new EventEmitter<void>();

  onCancel() { this.cancel.emit(); }
  onViewAll() { this.viewAll.emit(); }
}
